// extracted by mini-css-extract-plugin
export default {"container":"CommentedPage_container__OBW1P","menu":"CommentedPage_menu__HOIrV","menuLink":"CommentedPage_menuLink__Waa9M","content":"CommentedPage_content__iNCQI"};